import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseAdvancePrivateCompanyLeadProps {
  id?: string
  onSuccess: () => void
  onError: () => void
}

const useAdvancePrivateCompanyLead = ({ id, onSuccess, onError }: UseAdvancePrivateCompanyLeadProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['advancePrivateCompanyLead'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/private_company_leads/${id}/advance`)
    },
    onSuccess,
    onError,
  });
}

export default useAdvancePrivateCompanyLead